import React, { useContext } from "react";
import Select from "react-select";
import ItemModal from "./ItemModal/ItemModal";
import { toast } from "react-toastify";
import CustomerModal from "./ItemModal/CustomerModal";
import TableModal from "./ItemModal/TableModal";
import { Button } from "react-bootstrap";
import { OrderPrint } from "./OrderPrint";
import PasscodeAuthenticator from "../PasscodeAuthenticator/PasscodeAuthenticator";
import { gsap } from 'gsap';
import { MotionPathPlugin } from 'gsap/MotionPathPlugin';
import { TiArrowSortedDown } from "react-icons/ti";
import { SiFoodpanda } from "react-icons/si";
import CallCenterModal from "./ItemModal/CallCenterModal";
import CallCenterOrdertype from "./ItemModal/CallCenterOrdertype";
import InstructionModal from "./ItemModal/InstructionModal";
import RunningOrderModal from "./ItemModal/RunningOrderModal";
import "react-datepicker/dist/react-datepicker.css";
//functions
import {
  _t,
  currencySymbolLeft,
  currencySymbolRight,
  getSystemSettings,
  checkPermission,
  customStyle,
  // restaurantMenuLink,
} from "../../../../../functions/Functions";
// custom styles
import "./pos.css";

import { NavLink } from "react-router-dom";
import SettleOrder from "./settleOrder/SettleOrder";
import PosSelect from "./PosSelect";
import DropdownButton from "./DropdownButton";
import {
  calculatePriceForCartItem
} from "./helpers";
import CartItem from "./CartItem";
import "react-toastify/dist/ReactToastify.css";
import "react-confirm-alert/src/react-confirm-alert.css";
import PosModal from "./ItemModal/PosModal";
import CustomPosModal from "./ItemModal/CustomPosModal";
import usePosLogics from "./hooks/usePosLogics";
import CustomSpinLoader from "../../../../components/CustomSpinLoader";
import POSCardDropdown from "./ItemModal/POSCardDropdown";
import { FoodContext } from "../../../../../contexts/Food";

gsap.registerPlugin(MotionPathPlugin);

function Pos() {
  const {
    t,
    showSettle, 
    buttonDisabled, 
    availableDeptTags, 
    selectedDeptTag, 
    handleDeptTag, 
    handleSearch, 
    setSearchedFoodItem, 
    searchInput, 
    inputSearch, 
    activeFoodGroup, 
    handleFoodGroup, 
    availableFoodGroups, 
    orderCounter, 
    onlineOrder, 
    availableDeliveryTypes, 
    selectedDeliveryType, 
    selectedParty, 
    handleDeliveryType, 
    handleSelectedParty, 
    runningOrders, 
    editOrder, 
    authUserInfo, 
    modal9Show, 
    setModal9Show, 
    modalOrderType, 
    setModalOrderType, 
    setOrderDetails, 
    orderDetails, 
    newSettings, 
    generalSettings, 
    handleSetBranch, 
    zoneArea, 
    setZoneArea, 
    area, 
    setArea, 
    setDeliveryCharges, 
    selectedBranch, 
    setEditOrder,
    setModal10Show,
    taxHeight,
    setItemImage,
    itemImage,  
    selectTable,
    setSelectTable,
    tableId,
    selectedKot,
    setSelectedKot,
    setShowSettle,
    setButtonDisabled,  
    setSearchInput,
    discountInput,
    cartSubTotal,
    calculateTax,
    isLocked,
    authenticateStaffUser,
    onSuccessAuthenticationStaff,
    showPasswordPopup,
    hanleCancelAuthenticate,
    handleCardSubmit,
    cardModal,
    order_id,
    availableDeliveryParties,
    managerId,
    cartItems,
    setCartItems,
    cartTotal,
    deliveryCharges,
    roundOffPrice,
    getBeforeTaxPrice,
    theVatSettle,
    setTheVatSettle,
    setPaidMoney,
    setNewSettings,
    totalsettle,
    setTotalSettle,
    paidMoney,
    serviceCharges,
    foodItem,
    setFoodItem,
    loyaltyPoint,
    setloyaltyPoint,
    emptyCardOnChange,
    tokenNumber,
    theVat,
    theTax,
    setTheVat,
    returnMoneyUsd,
    setReturnMoneyUsd,
    isSettle,
    handleLocalPrint,
    handleReceiptPrint,
    handleKotItems,
    paymentTypeAvailable,
    fbrInvoiceNum,
    srbInvoiceNum,
    token_No,
    newOrder,
    foodGroupsToPrint,
    con_Kot,
    taxType,
    component2Ref,
    barcodePrintRef,
    managerPasscode,
    setComponentUnlock,
    setManagerId,
    componentUnlock,
    backModal,
    setBackModal,
    emptyCard,
    cashDetails,
    setCashDetails,
    noteRiderModal,
    setNoteRiderModal,
    handlePreOrder,
    addReasonOnSubmit,
    setAddFocItem,
    handleFocItem,
    addFocItem,
    setAddReasonModalShowing,
    addReasonModalShowing,
    deleteReason,
    setDeleteReason,
    setPaymentTypeModalState,
    paymentTypeModalState,
    callCenterPayment,
    setCallCenterPayment,
    workPeriodScreen,
    branchForSearch,
    searchedFoodItem,
    flyStart,
    animate,
    handleFoodItemClicked,
    handleCloseItemModal,
    menuWisePrice,
    showModal,
    selectedFoodItem,
    selectedFoodItemId,
    addToCart,
    cardAnimate,
    deleteCartItem,
    editCartItem,
    deleteOneCartItem,
    handleSetItemQty,
    handleSetItemPrice,
    handleSetItemDiscount,
    deletedItemsOnEdit,
    setCommentId,
    userLock,
    itemAdd,
    modal10Show,
    setTableId,
    guestSelected,
    setGuestSelected,
    commentId,
    updateItemImage,
    updateComments,
    taxScroll,
    handleTaxOnPaymentTypeChange,
    deliveryInput,
    hanldeDiscountPercent,
    toastObj,
    tempSchemeForSearch,
    schemeForSearchObj,
    handleSetOffer,
    paymentOptions,
    currentNavPill,
    handlePaymentType,
    loading,
    handleSubmitOrder,
    handlePreOrderConfirmation,
    syncOrder, 
    syncLocalOrders,
    handleSettleOrderButton,
    handleFocConfirmation,
    componentRef,
    handlePunchOrder,
    isFoodLoading
  } = usePosLogics();

  const { menuForPos } = useContext(FoodContext)

  //food item conditon
  const foodItemVisible = (Object.keys(menuForPos)?.length) && orderDetails.branch &&
  selectedDeptTag && activeFoodGroup && menuForPos[selectedDeptTag.id]&&
  menuForPos[selectedDeptTag.id][orderDetails.branch.id] &&
  menuForPos[selectedDeptTag.id][orderDetails.branch.id][activeFoodGroup];

  const handleDisable = (foodItem) => {
    const isDisabled = !!(orderDetails.is_split || (generalSettings && 
      (selectedParty?.name.toLowerCase() !== "pre order") && 
      parseInt(getSystemSettings(generalSettings, "fgs_enable")) === 1 &&
      (foodItem?.stock_qty <= 0 || foodItem?.stock_qty == undefined) && 
      foodItem?.is_deal === 0 && !foodItem?.is_recipe)) || isFoodLoading;
    return isDisabled  
  }

  const Isshowtags = (foodItem) => {
    return (
      generalSettings &&
      selectedParty?.name.toLowerCase() !== "pre order" &&
      parseInt(getSystemSettings(generalSettings, "fgs_enable")) === 1 &&
      foodItem?.is_deal === 0 &&
      !foodItem?.is_recipe
    );
  };

  const renderFoodQty = (foodItem)=>{
    if (!foodItem) return null;
    return (
      foodItem?.stock_qty <= 0 || foodItem?.stock_qty == undefined ?
      <span className= "position-absolute stockQty stock-bg-danger"> 
        Out of stock
      </span>
      :
      <span className= "position-absolute stockQty stock-bg"> 
        Qty : {" " + foodItem?.stock_qty}
      </span>
    )
  }

  return (
    <>
      <div
        className={`pos--main-container bg-white row m-0 p-0 ${!showSettle ? "" : "d-none"}`}
      >
        <CustomSpinLoader loading={buttonDisabled}/>
      
        {/* category sidebar */}
        <div className="category-box mt-0 bg-white col col-2 d-flex flex-column px-0 py-2 mh-inherit shadow">
          <PosSelect
            isSearchable={false}
            options={availableDeptTags && availableDeptTags}
            value={selectedDeptTag}
            getOptionLabel={(a) => a.name}
            getOptionValue={(a) => a.name}
            placeholder="Select Menu"
            className="mt-2 mb-2 mx-2"
            onChange={(e) => {
              if (order_id) {
                toast.error(
                  "Can't change order type/party on edit complete the current order"
                );
              } else {
                handleDeptTag(e);
              }
            }}
          />
          <div className="pos--left-inner-addon mx-2">
            <input
              type="search"
              className="form-control pr-4"
              placeholder="Search"
              ref={inputSearch}
              value={searchInput}
              onChange={(e) => handleSearch(e)}
            />
            <i
              className="fa fa-search search pt-2"
              onClick={() => {
                setSearchedFoodItem({ list: null, searched: false });
                setSearchInput("");
                if (inputSearch.current) inputSearch.current.value = "";
              }}
            ></i>
          </div>
          <div className="flex-grow-1" data-simplebar>
            <div className="hover_category mb-4">
              <div className="pos--category-nav d-flex flex-column">
                {menuForPos && selectedDeptTag && Object.keys(availableFoodGroups).length ? (
                  availableFoodGroups[selectedDeptTag.id]?.map((foodGroup) => {
                    const shouldShowFoodGroup = !orderDetails?.branch ||
                        (orderDetails.branch && menuForPos?.[selectedDeptTag?.id]?.[orderDetails.branch.id]?.[foodGroup?.id]);

                    if(shouldShowFoodGroup){
                      return (
                        <span
                          key={foodGroup.id}
                          className={`pos--category-nav-item d-flex align-items-center font-weight-bold rounded-05 ${
                            activeFoodGroup === foodGroup.id ? "active" : ""
                          }`}
                          onClick={() => handleFoodGroup(foodGroup)}
                        >
                          <div>{foodGroup.name}</div>
                          {activeFoodGroup === foodGroup.id ? (
                            <i className="fa fa-arrow-right ml-1"></i>
                          ) : (
                            ""
                          )}
                        </span>
                      )
                    }
                  })
                ) : (
                  <span></span>
                )}
              </div>
            </div>
          </div>
        </div>
        {/* main content */}

        <div className="col mh-inherit mt-0">
          <div className="d-flex justify-content-between align-items-center">
            <div className="pos--options-container mt-1 mb-2 pt-3 ml-2 col">
              {
                authUserInfo.details?.order_type_id && typeof(authUserInfo.details.order_type_id) === "string" ?
                onlineOrder.current && (
                  <NavLink
                    className="pos--btn btn mr-1 mb-1 bg-primary text-white"
                    to={"/dashboard/pos/online-orders"}
                  >
                    Online Odr
                    {orderCounter?.online > 0 && (
                      <span className=" rounded-md special-category">
                        ({orderCounter.online})
                      </span>
                    )}
                  </NavLink>
                ) : (
                  <NavLink
                    className="pos--btn btn mb-1 mr-1 bg-primary text-white"
                    to={"/dashboard/pos/online-orders"}
                  >
                    Online Odr
                    {orderCounter?.online > 0 && (
                      <span className=" rounded-md special-category">
                        ({orderCounter.online})
                      </span>
                    )}
                  </NavLink>
                )
              }
             
              {availableDeliveryTypes && availableDeliveryTypes?.length
                ? availableDeliveryTypes.map((deliveryType, index) => (
                    <DropdownButton
                      index={index}
                      value={deliveryType}
                      isSelected={deliveryType.id === selectedDeliveryType?.id}
                      setSelected={handleDeliveryType}
                      getLabel={(dt) => dt.name}
                      options={availableDeliveryParties && availableDeliveryParties[deliveryType.id]}
                      selectedSubItem={selectedParty}
                      setSelectedSubItem={handleSelectedParty}
                      getSubItemLabel={(p) => p.name}
                    />
                  ))
                : null}
              {authUserInfo.details.user_type !== "call_center" && (
                <>
                 {authUserInfo.details.user_type !== "waiter" && (
                  <NavLink
                    className="pos--btn btn mb-1 mr-1 bg-primary text-white"
                    to={"/dashboard/pos/settled"}
                  >
                    Settled
                  </NavLink>
                 )} 

                  <div className="d-inline-block mb-1 btn-group">
                    <NavLink
                      className={`dropdwn--btn btn text-white bg-primary text-decoration-none ${
                        runningOrders && runningOrders.list?.length > 0
                          ? ""
                          : "mr-2 rounded-05"
                      }`}
                      to={"/dashboard/pos/submitted"}
                    >
                      Running Odr.
                      {orderCounter?.ready > 0 && (
                        <span className=" rounded-md special-category">
                          ({orderCounter.ready})
                        </span>
                      )}
                    </NavLink>
                    {runningOrders && runningOrders.list?.length > 0 && (
                      <button
                        data-ignore="true"
                        className="dropdwn1--btn  btn bg-primary text-white mr-1"
                        onClick={() => setEditOrder((curr)=>!curr)}
                      >
                        <i data-ignore="true" className="fa-sharp fa fa-caret-down lg-text" />
                      </button>
                    )}
                    {editOrder && (
                      <RunningOrderModal setEditOrder={setEditOrder} editOrder={editOrder}/>
                    )}
                  </div>
                </>
              )}
              {
                authUserInfo.details.user_type === "call_center" && parseInt(getSystemSettings(generalSettings, "call_center_enable")) === 1 ? (
                  <>
                    <CallCenterModal
                      modal9Show={modal9Show}
                      setModal9Show={setModal9Show}
                      setModalOrderType={setModalOrderType}
                      setOrderDetails={setOrderDetails}
                      orderDetails={orderDetails}
                      selectedParty={selectedParty}
                      checkDelivery={selectedDeliveryType && selectedDeliveryType?.name.toLowerCase() === "delivery"}
                      newSettings={newSettings}
                      handleSetBranch={handleSetBranch}
                      zoneArea={zoneArea}
                      setZoneArea={setZoneArea}
                      area={area}
                      setArea={setArea}
                      setDeliveryCharges={setDeliveryCharges}
                      selectedBranch={selectedBranch}
                      workPeriodScreen={workPeriodScreen}
                    />
                    <CallCenterOrdertype 
                      modalOrderType={modalOrderType}
                      setModalOrderType={setModalOrderType}
                      setModal9Show={setModal9Show}
                      selectedParty={selectedParty}
                      selectedDeliveryType={selectedDeliveryType}
                      availableDeliveryTypes={availableDeliveryTypes}
                      handleDeliveryType={handleDeliveryType}
                      handleSelectedParty={handleSelectedParty}
                      availableDeliveryParties={availableDeliveryParties}
                    />
                  </>

                ):(
                  <CustomerModal
                    showSettle={showSettle}
                    modal9Show={modal9Show}
                    setModal9Show={setModal9Show}
                    setOrderDetails={setOrderDetails}
                    orderDetails={orderDetails}
                    selectedParty={selectedParty}
                    checkDelivery={selectedDeliveryType && selectedDeliveryType?.name.toLowerCase() === "delivery"}
                  />
                )
              }
              
              <Button
                className="pos--btn mb-1 btn bg2-success xlg-text pos--icon-btn text-white border-0 mr-1"
                onClick={() =>
                  selectedParty
                    ? setModal9Show(true)
                    : toast.error("Please select party type")
                }
                disabled={(parseInt(getSystemSettings(generalSettings, "online_order_edit")) === 1 &&
                  selectedParty?.name === "Website" && orderDetails?.is_edit)}
              >
                <i className="fa fa-user-plus new-btn"></i>
              </Button>
              {authUserInfo.details.user_type !== "call_center" && (
                <span>
                  {(parseInt(orderDetails.branch?.table_waiter) || parseInt(
                    getSystemSettings(generalSettings, "table_waiter")
                  ) === 1) ? (
                    selectedDeliveryType &&
                    selectedDeliveryType.name.match(/dine(.*)in/i) ? (
                      <Button
                        className="pos--btn btn mb-1 mr-1 bg2-success xlg-text pos--icon-btn text-white border-0"
                        onClick={() =>
                          selectedDeliveryType &&
                          selectedDeliveryType.name.match(/dine(.*)in/i)
                            ? setModal10Show(true)
                            : toast.error("Please select Dine In ")
                        }
                      >
                        <i className="fa fa-address-card new-btn"></i>
                      </Button>
                    ) : (
                      <></>
                    )
                  ) : (
                    <></>
                  )}
                </span>
              )}
              {
                parseInt(getSystemSettings(generalSettings, "foodPanda_integration")) === 1 && authUserInfo.details.user_type !== "waiter" && (
                <NavLink 
                  ref={taxHeight}
                  className="btn foodPanda-btn text-white mr-1 mb-1"
                  to={"/dashboard/pos/foodpanda"}
                >
                <span className="d-flex align-items-center">
                 <SiFoodpanda  className="foodPandabtn mr-1"/>
                  Food Panda 
                  {orderCounter?.foodPanda > 0 && (
                    <span className=" pl-1 rounded-md special-category">
                      ({orderCounter.foodPanda})
                    </span>
                  )}
                </span>
                 {/* <img className="ml-1" style={{height:"1.2rem", borderRadius:"2px"}} src={FPRider}  alt=""/>*/}
                 
                </NavLink>
                )
              }
              
              <Button className="pos--btn btn bg2-success xlg-text pos--icon-btn text-white border-0 mr-1 mb-1" onClick={()=>setItemImage(!itemImage)}>
               {
                itemImage ? 
                <i className="fa fa-th-list" aria-hidden="true"></i>
                :
                <i className="fa fa-th" aria-hidden="true"></i>
                }
              </Button>               

              <TableModal
                show={modal10Show}
                onHide={() => setModal10Show(false)}
                modal10Show={modal10Show}
                setModal10Show={setModal10Show}
                orderDetails={orderDetails}
                setOrderDetails={setOrderDetails}
                selectedDeliveryType={selectedDeliveryType}
                selectedParty={selectedParty}
                selectedDeptTag={selectedDeptTag}
                selectTable={selectTable}
                setSelectTable={setSelectTable}
                tableId={tableId}
                setTableId={setTableId}
                guestSelected={guestSelected}
                setGuestSelected={setGuestSelected}
                buttonDisabled={buttonDisabled}
              />
            </div>
            {/* Branch select Dropdown*/}
            <div className="col-2 mr-2 mt-2 mb-2 pt-3">
              {authUserInfo.details &&
                (authUserInfo.details.user_type !== "staff" && authUserInfo.details.user_type !== "manager" && authUserInfo.details.user_type !== "waiter" ) ? (
                  <Select
                    options={branchForSearch || []}
                    getOptionLabel={(option) => option.name}
                    getOptionValue={(option) => option.id}
                    value={selectedBranch}
                    onChange={(branch) => handleSetBranch(branch)}
                    classNamePrefix="Branch"
                    className="sm-text"
                    maxMenuHeight="13rem"
                    placeholder="Branch"
                    styles={customStyle}
                  />
                ) : (
                  <div className="user_branch_name  text-right">
                    {orderDetails?.branch?.name}{" "}
                  </div>
                )
              }
            </div>
          </div>

          {/* main container */}
          <div className="row pos--main-content-wrapper">
            <div
              className="col d-flex flex-row pt-1 p-3 pr-4 menu-left"
              data-simplebar
            >
              <div className="pos--menu-container row m-0 flex-grow-1">
                <div className="col flex-grow-1 mh-100 p-1">
                  <div className="pos--menu-items-conatiner row m-0 flex-wrap">
                  {!searchedFoodItem.searched
                    ? (foodItemVisible
                      ? (menuForPos[selectedDeptTag.id][orderDetails.branch.id][activeFoodGroup]?.map((foodItem) => (
                            <div
                              ref={flyStart}
                              key={foodItem.id}
                              title={foodItem?.item_description}
                              className={`font-weight-bold pos--menu-item rounded-05 mr-2 mb-2 ${handleDisable(foodItem) ? "disabled" : ""}`}
                              onClick={(e) =>{
                                if(!buttonDisabled){
                                  handleFoodItemClicked(foodItem,e)
                                }
                              }}
                            >
                              <figure className="position-relative w-100">
                                {Isshowtags(foodItem) &&
                                  renderFoodQty(foodItem)
                                }                                    
                                <img
                                  src={ foodItem.image || "/assets/img/default-item.jpeg" }
                                  alt=""
                                  className={`img-fluid item-img ${itemImage ? "d-none" : ""}`}
                                  loading="lazy"
                                  onError={(e) => { e.target.onerror = null; e.target.src = "/assets/img/default-item.jpeg" }}
                                />
                                <figcaption className={`item-name text-center px-2 ${itemImage ? "mt-4 mb-0" : "mt-2"}`}>
                                  {foodItem.name}
                                </figcaption>
                              </figure>
                            </div>
                          )
                        )
                      ) : null)
                      : (foodItemVisible ? (searchedFoodItem.list?.map((foodItem,index) => (
                          <div
                            ref={flyStart}
                            title={foodItem?.item_description}
                            key={index}
                            className={`font-weight-bold pos--menu-item rounded-05 mr-2 mb-2 ${handleDisable(foodItem) ? "disabled" : ""}`}
                            onClick={(e) =>{
                              if(!buttonDisabled){
                                handleFoodItemClicked(foodItem,e)
                              }
                            }}
                          >
                            <figure className="position-relative w-100">
                              {Isshowtags(foodItem) &&
                                renderFoodQty(foodItem)
                              }
                              <img
                                src={ foodItem.image || "/assets/img/default-item.jpeg" }
                                alt=""
                                className={`img-fluid item-img ${itemImage ? "d-none" : ""}`}
                                onError={(e) => { e.target.onerror = null; e.target.src = "/assets/img/default-item.jpeg" }}
                              />
                              <figcaption className={`item-name text-center px-2 ${itemImage ? "mt-4 mb-0" : "mt-2"}`}>
                                {foodItem.name}
                              </figcaption>
                            </figure>
                          </div>
                        ))
                      ) : null)}
                    <ItemModal
                      closeModal={handleCloseItemModal}
                      showModal={showModal}
                      itemData={selectedFoodItem}
                      itemId={selectedFoodItemId}
                      addToCart={addToCart}
                      buttonDisabled={buttonDisabled}
                      menuWisePrice = {menuWisePrice.current}
                      menuId = {selectedDeptTag?.id}
                    />
                  </div>
                </div>
              </div>
            </div>
            {((parseInt(getSystemSettings(generalSettings, "call_center_enable")) === 1 ? authUserInfo.details.user_type !== "call_center" : true) && (((newSettings && newSettings.workPeriod === null)) || workPeriodScreen == 0)) && (
              <div className="fk-overlay">
                <div className="fk-left-overlay__content text-center m-auto">
                  <h6
                    className={`text-primary text-uppercase ${
                      authUserInfo.details &&
                      (authUserInfo.details.user_type !== "staff" && authUserInfo.details.user_type !== "manager" && authUserInfo.details.user_type !== "waiter") &&
                      "mb-0"
                    }`}
                  >
                    
                    {workPeriodScreen == 1 ? authUserInfo.details &&
                    (authUserInfo.details.user_type !== "staff" && authUserInfo.details.user_type !== "manager" && authUserInfo.details.user_type !== "waiter")
                      ? _t(t("Select branch to active POS"))
                      : _t(t("start workperiod")) : _t(t("Close previous workperiod")) }
                  </h6>
                  <div className="m-auto col-8 mt-3">
                    {authUserInfo.details &&
                      (authUserInfo.details.user_type !== "staff" && authUserInfo.details.user_type !== "manager" && authUserInfo.details.user_type !== "waiter") && (
                        <>
                          <Select
                            options={branchForSearch || []}
                            getOptionLabel={(option) => option.name}
                            getOptionValue={(option) => option.id}
                            value={selectedBranch}
                            onChange={(branch) => handleSetBranch(branch)}
                            classNamePrefix="Branch"
                            className="sm-text"
                            maxMenuHeight="13rem"
                            placeholder="Branch"
                            styles={customStyle}
                          />
                          <h4 className="mt-2 text-uppercase new-sm-text mb-2">
                            {_t(t("Start workperiod if it is not started"))}
                          </h4>
                        </>
                      )}
                  </div>
                  <NavLink
                    to="/dashboard/work-periods"
                    className="t-heading-font btn btn-success btn-sm text-uppercase sm-text"
                  >
                    {_t(t("Start Your Work Period"))}
                  </NavLink>
                </div>
              </div>
            )}

            <div className="col-5 pt-2 pr-cart bill-right">
              <div className="pos--bill-container rounded-25 w-80 d-flex flex-column pb-2">
                <div className="cart-1">
                  <div className="d-flex align-items-center justify-content-between bussines-day font-weight-md btn-primary rounded-top">
                    <div className="d-flex align-items-center justify-content-between mx-2">
                      <div>
                        Business Day: {newSettings?.workPeriod && newSettings.workPeriod?.date}
                      </div> 
                    </div>
                    <button
                      disabled={buttonDisabled}
                      className=" btn btn-light xsm-text text-uppercase py-1 boxShadow-none"
                      style={{borderRadius:"0 .25rem 0 0", borderBottom: "1px solid #dddddd"}}
                      onClick={(e) => setBackModal(true)}
                    >
                      Back
                    </button>
                  </div>
                  <h6 className="py-1 px-2 mb-0 font-weight-bold border-bottom d-flex justify-content-between">
                    {selectedDeliveryType &&
                      `${
                        selectedDeliveryType
                          ? selectedDeliveryType.name + " "
                          : ""
                      } - `}
                    {selectedParty ? selectedParty.name : ""}
                    <div
                      className="m-0 ml-2 text-capitalize lg-text"
                    >
                      {orderDetails?.token
                        ? (getSystemSettings(generalSettings, "token_text") && getSystemSettings(generalSettings, "token_text")?.slice(0,5)) + " # " + orderDetails.token.id
                        : ""}
                    </div>
                  </h6>
                </div>

                <div className="flex-grow-1 px-2 container-fluid">
                  <div className="mx-1 item_variation d-flex flex-row justify-content-between border-bottom bill-list">
                    <div className="text-capitalize d-inline-block fw-normal col-4">
                      Food Item
                    </div>
                    <div className="text-capitalize col-3 text-center">
                      Qty
                    </div>
                    <div className="text-capitalize col-1 text-center">
                      Dis %
                    </div>
                    <div className="text-capitalize col-1 text-center">
                      Dis
                    </div>
                    <div className="text-capitalize col-3 text-right">
                      Price
                    </div>
                  </div>
                  {/* <div className="simplebar-scrollbar"> */}
                  <div className="items-wrap ">
                    {cartItems && Object.keys(cartItems).length
                      ? Object.keys(cartItems)
                          .sort((a, b) =>
                            cartItems[a].seq < cartItems[b].seq ? 1 : -1
                          )
                          .map((itemHash) => {
                            return (
                            <div key={itemHash} ref={(e)=> cardAnimate.current[itemHash] = e} className="cart-item-wrapper">
                              <CartItem
                                itemId={itemHash}
                                animate={animate}
                                item={cartItems[itemHash]}
                                deleteItem={deleteCartItem}
                                editItem={editCartItem}
                                addToCart={addToCart}
                                deleteOneCartItem={deleteOneCartItem}
                                setAddReasonModalShowing={
                                  setAddReasonModalShowing
                                }
                                setAddFocItem={setAddFocItem}
                                handleSetItemQty={handleSetItemQty}
                                handleSetItemPrice={handleSetItemPrice}
                                handleSetItemDiscount={handleSetItemDiscount}
                                orderDetails = {orderDetails}
                                deletedItemsOnEdit = {deletedItemsOnEdit}
                                setCommentId={setCommentId}
                                userLock={userLock}
                                itemAdd={itemAdd}
                                authenticateStaffUser={authenticateStaffUser}
                                isOpenQty = {parseInt(getSystemSettings(generalSettings,"open_qty_box")) === 1}
                                isLocked={isLocked}
                                getPrice={(p) =>
                                  roundOffPrice(
                                    p.after_tax_price ?? 
                                    getBeforeTaxPrice(
                                      calculatePriceForCartItem(p)
                                    )
                                  )
                                }
                              />
                            </div>
                          )})
                      : null}

                      {cartItems && Object.keys(cartItems).length && commentId ? (
                        <InstructionModal
                          cartItems={cartItems}
                          updateItemImage={updateItemImage}
                          animate={animate}
                          commentId={commentId}
                          setCommentId={setCommentId}
                          updateComments={updateComments}
                        />
                        ) : null
                      }
                  </div>
                </div>
                {/* </div> */}

                <div className="col-12 p-0 m-0 t mt-10">
                  <div className="">
                    <div className="container-fluid">
                      <div className="row  border-bottom p-1 px-2">
                        {/*Subtotal*/}
                        <div className="col-6">
                          <div className=" d-flex flex-row justify-content-between">
                            <span className="text-capitalize d-inline-block total-bill">
                              SubTotal
                            </span>
                            <span className="text-capitalize sm-text d-inline-block font-weight-bold text-right mr-3">
                              {currencySymbolLeft()}
                              {cartSubTotal}
                              {currencySymbolRight()}
                            </span>
                          </div>
                        </div>
                        {/*Tax*/}
                        <div className="col-6">
                          <div className="d-flex flex-row justify-content-evenly">
                            <span className="text-capitalize total-bill d-inline-block col-6 position-relative">
                              Tax
                              <span className=" text-capitalize total-bill text-center font-weight-bold text-right ">
                                ({theTax && theTax + "%"})
                              </span>
                               {
                                parseInt(
                                  getSystemSettings(
                                    generalSettings,
                                    "payment_type_tax_calculation"
                                  )
                                ) === 1 && (
                                  <TiArrowSortedDown  className="dashboard_card_down cursor-pointer" onClick={()=> setPaymentTypeModalState({
                                    ...paymentTypeModalState,
                                    taxCalSelect : !paymentTypeModalState.taxCalSelect
                                  })}/>
                                )
                                }
                              {paymentTypeModalState.taxCalSelect === true && (
                                <div className={`taxSelect 
                                  ${taxScroll.current?.actualHeight >=
                                  taxScroll.current?.overflowHeight ? 
                                  "pr-1" : ""}`}
                                > 
                                  {paymentTypeAvailable && paymentTypeAvailable?.map((groupItem, groupIndex)=>{
                                    return (
                                      <span className="m-0 p-0" key={groupIndex} onClick={() => {
                                        handleTaxOnPaymentTypeChange(groupItem)
                                      }}>
                                        <li className={`list-unstyled dashboard_border p-1 cursor-pointer ${groupIndex == (paymentTypeAvailable?.length - 1) ? "mb-0" : "mb-1"}`}>{groupItem.name}</li>
                                      </span>
                                    )
                                  })
                                  }
                                </div>
                              )}
                            </span>
                            <span className="text-capitalize total-bill d-inline-block font-weight-bold col-6 text-right pl-4">
                              <>
                                {theTax &&
                                  currencySymbolLeft() +
                                    theVat +
                                    currencySymbolRight()}
                              </>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Input tags */}
                    <div className="input_fields d-flex flex-row flex-wrap align-items-center justify-content-between my-1 mx-1 px-2">
                      <div className="col-4 my-1 d-flex align-items-center">
                        <label className="total-bill col-5 font-weight-bold mr-1 pl-2" htmlFor="delivery">
                          D.C:
                        </label>
                        <input
                          disabled={deliveryInput.current}
                          className="form-control cartInput rounded-25"
                          type="number"
                          onKeyDown={(evt) =>
                            ["e", "E", "+", "-","ArrowUp","ArrowDown",].includes(evt.key) &&
                            evt.preventDefault()
                          }
                          onWheel={(e) => e.target.blur()}  
                          min="0"
                          value={deliveryCharges}
                          onChange={(e) => setDeliveryCharges(e.target.value)}
                        />
                      </div>
                      <div className="col-4 px-2 my-1">
                        <span className="total-bill text-center d-flex flex-row">
                          <span className=" font-weight-bold mr-1">
                            S.C(
                            {orderDetails?.branch &&
                              orderDetails.branch?.service_fees}
                            %):
                          </span>
                          <span>{currencySymbolLeft()}{serviceCharges.toFixed(2)}{currencySymbolRight()}</span>
                        </span>
                      </div>
                      <div className="col-4 my-1 d-flex align-items-center">
                        <label className={`total-bill ${ orderDetails.scheme.open_discount ? "col-6" : "col-5"} d-flex align-items-center font-weight-bold mr-1 text-center`}>
                          Dis:
                          {
                            orderDetails.scheme.open_discount ? (
                              <input
                                title="Discount percent"
                                className="ml-1 form-control cartInput rounded-25 px-2"
                                type="number"
                                onKeyDown={(evt) =>
                                  ["e", "E", "+", "-","ArrowUp","ArrowDown",].includes(evt.key) &&
                                  evt.preventDefault()
                                }
                                onWheel={(e) => e.target.blur()}  
                                min="0"
                                max="100"
                                placeholder="%"
                                value={orderDetails.scheme.how_much_discount || ""}
                                onChange={(e) => hanldeDiscountPercent(cartSubTotal, e.target.value)}
                              />
                            ) : ""
                          }
                        </label>
                        <input
                          disabled={newOrder?.length === 0 || (orderDetails.scheme.open_discount ? orderDetails.scheme.how_much_discount : discountInput.current) }
                          className="form-control cartInput rounded-25 "
                          type="number"
                          onKeyDown={(evt) =>
                            ["e", "E", "+", "-","ArrowUp","ArrowDown",].includes(evt.key) &&
                            evt.preventDefault()
                          }
                          onWheel={(e) => e.target.blur()}  
                          min="0"
                          placeholder="Discount"
                          value={orderDetails.scheme.discount_amount}
                          onChange={(e) => {
                            const baseAmount = orderDetails.scheme?.discount_tax
                              ? (cartSubTotal + theVat) : cartSubTotal;
                            
                            if(parseFloat(e.target.value) > baseAmount){
                              toast.error(
                                `${_t(t("You can't type discount greater than bill amount"))}`,
                                toastObj
                              )
                            }else{
                              setOrderDetails({
                                ...orderDetails,
                                scheme:{
                                  ...orderDetails.scheme,
                                  discount_amount: e.target.value
                                }
                              });
                              calculateTax(cartSubTotal, e.target.value)
                            }}
                          }
                        />
                      </div>
                    </div>
                    <div className="mt-1 container-fluid">
                      <div className="row justify-content-between mb-1">
                        <div className="col-1 d-flex align-items-center">
                          {isLocked("offer_cp") &&
                          parseInt(
                            getSystemSettings(
                              generalSettings,
                              "offers_lock_status"
                            )
                          ) === 1 ? (
                            <div
                              className="cursor-pointer mx-1 d-flex align-items-center"
                              onClick={(e) => authenticateStaffUser("offer_cp")}
                            >
                              <i className="fa fa-lock lock_icon"></i>
                            </div>
                          ) : (
                            <div className="text-success mx-1 d-flex align-items-center">
                              <i className="las la-lock-open lock_icon"></i>
                            </div>
                          )}
                        </div>
                        <div className="col-5">
                          {tempSchemeForSearch !== null &&
                          tempSchemeForSearch?.length !== 0 ? (
                            <span className="position-relative offer-tip">
                              <span
                                className={`${
                                  isLocked("offer_cp") &&
                                  parseInt(
                                    getSystemSettings(
                                      generalSettings,
                                      "offers_lock_status"
                                    )
                                  ) === 1
                                    ? "tool-tip"
                                    : "disable-tip"
                                }`}
                              >
                                please unlock offer
                              </span>
                              <Select
                                isDisabled={
                                  (isLocked("offer_cp") &&
                                  parseInt(
                                    getSystemSettings(
                                      generalSettings,
                                      "offers_lock_status"
                                    )
                                  ) === 1) || buttonDisabled || 
                                  (parseInt(getSystemSettings(generalSettings, "online_order_edit")) === 1 &&
                                  selectedParty?.name === "Website" && orderDetails?.is_edit)
                                }
                                isSearchable={true}
                                options={tempSchemeForSearch}
                                getOptionLabel={(option) => option.name}
                                getOptionValue={(option) => option.id}
                                value={
                                  orderDetails.scheme?.scheme_id
                                    ? schemeForSearchObj[
                                        orderDetails.scheme?.scheme_id
                                      ]
                                    : null
                                }
                                onChange={(offer) => handleSetOffer(offer)}
                                classNamePrefix="Offers"
                                className="sm-text rounded-25 cursor-pointer"
                                menuPlacement="top"
                                maxMenuHeight="13rem"
                                placeholder="Offers"
                                styles={{
                                  indicatorSeparator: (provided) => ({
                                    ...provided,
                                    display: "none",
                                  }),
                                  control: (provided) => ({
                                    ...provided,
                                    fontSize: "0.9rem",
                                    borderRadius: ".3rem",
                                    borderColor: "#27ccaa",
                                    minHeight: "1.5rem",
                                    maxHeight: "2rem",
                                    marginTop: "0",
                                    marginBottom: "0",
                                  }),
                                  dropdownIndicator: (provided) => ({
                                    ...provided,
                                    color: "#27ccaa",
                                    padding: "0 5px 0 0",
                                    margin: "0",
                                    svg: {
                                      maxHeight: "2rem",
                                    },
                                  }),
                                  valueContainer: (provided) => ({
                                    ...provided,
                                    fontSize: "0.9rem",
                                    padding: "0 0.3rem",
                                    margin: "0",
                                    maxHeight: "2rem",
                                  }),
                                  inputContainer: (provided) => ({
                                    ...provided,
                                    margin: "0",
                                  }),
                                  input: (provided) => ({
                                    ...provided,
                                    margin: "0",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                  }),
                                }}
                              />
                            </span>
                          ) : (
                            <span></span>
                          )}
                        </div>
                        <div className="col-6 d-flex justify-content-end print-cancel-row align-items-center">
                          <span className="mr-2 font-weight-bold bill-total">
                            Total Bill:
                          </span>
                          <span className="font-weight-bold mr-1 bill-total">
                            <>
                              {currencySymbolLeft()}
                              {cartTotal}
                              {currencySymbolRight()}
                            </>
                          </span>
                        </div>
                      </div>
                      {/* <div className="d-flex justify-content-between align-items-center">
                        <div className="col-7 row">
                          <div className="mr-1 col-6">
                             <button
                              type="button"
                              className="w-100 btn btn-success xsm-text text-uppercase col-3"
                            >
                              Print Bill
                            </button>
                          </div>

                          <div className="col-4 m-0 p-0 cancel-btn">
                            <button
                              type="button"
                              className="w-100 btn btn-success2 xsm-text text-uppercase col-6"
                              onClick={emptyCard}
                            >
                              cancel
                            </button>
                          </div>
                        </div>
                      </div> */}

                      <div className="bill-last-row row mt-2 mb-2">
                        <div className={`${authUserInfo.details.user_type !== "call_center" ? "col-7" : "col-8"} d-flex align-items-center`}>
                          {authUserInfo.details.user_type === "call_center" && (
                            <>
                              <div
                                aria-label="payment Type"
                                className="indolj-switcher-container mx-1"
                              >
                                {paymentOptions.map((paymentOption) =>
                                  (
                                    <div
                                      className={`switch ${
                                        callCenterPayment.payment_type == paymentOption
                                          ? "active-switch"
                                          : ""
                                      }`}
                                      key={paymentOption}
                                      ref={(e) =>
                                        callCenterPayment.payment_type == paymentOption
                                          ? currentNavPill(e)
                                          : null
                                      }
                                      onClick={() =>
                                        handlePaymentType(paymentOption)
                                      }
                                    >
                                      {paymentOption}
                                    </div>
                                  )
                                )}
                                <div className="driveActive"></div>
                              </div>
                            </>
                          )}
                          <div className=" ml-1 fk-calculator-container calculator-btn mr-1">
                            {
                              /*
                              <button
                                className="fa fa-calculator btn btn-info text-uppercase w-100 h-1000 rounded-25"
                                onClick={() => setCalculatorMenu(!calculatorMenu)}
                              ></button>
                              <div
                                className={`calculator ${
                                  calculatorMenu && "active"
                                }`}
                              >
                                <Calculator />
                              </div>
                            */
                             }  
                              {/* <button
                                title="Rider Note"
                                disabled={buttonDisabled}
                                className="btn btn-primary sm-text text-uppercase rounded-25 px-2 py-1"
                                onClick={(e) =>
                                  newOrder && newOrder.length > 0
                                    ? setNoteRiderModal(true)
                                    : toast.error("Please select item first")
                                }
                              >
                                <img src="/assets/img/writing.png" style={{maxHeight:"1.25rem"}} alt=""/>
                              </button> */}
                            <POSCardDropdown 
                              newOrder={newOrder}
                              setOrderDetails= {setOrderDetails}
                              setNoteRiderModal={setNoteRiderModal}
                              handleSubmitOrder={handleSubmitOrder}
                              buttonDisabled={buttonDisabled}
                            />
                          </div>

                          {authUserInfo.permissions !== null &&
                            checkPermission(
                              authUserInfo.permissions,
                              "Submit"
                            ) ? (
                              <>
                                {/* {authUserInfo.details.user_type !== "call_center" && (
                                  <button
                                    disabled={buttonDisabled || order_id}
                                    type="button"
                                    className="ml-1 btn btn-danger sm-text text-uppercase rounded-25 btn-card-bottom font-weight-bold hover-effect"
                                    onClick={(e) =>{
                                      if(!loading){ 
                                        handleSubmitOrder(e, 1)
                                      }
                                    }}
                                  >
                                    {!loading ?
                                      _t(_t("hold"))
                                      :  _t(_t("Please wait"))}
                                  </button>
                                )} */}
                                <button
                                  disabled={buttonDisabled || selectedParty?.name.toLowerCase() !== "pre order"}
                                  className="ml-1 font-weight-bold btn btn-success btn-card-bottom sm-text text-uppercase rounded-25"
                                  onClick={(e) => handlePreOrderConfirmation(e)}
                                >
                                  Pre Od
                                </button>
                              </>
                            ) : (
                              ""
                            )}
                            {
                              navigator.onLine && authUserInfo.details.user_type !== "call_center" && (
                                <button
                                disabled={buttonDisabled || syncOrder}
                                type="button"
                                className="mx-1 btn btn-secondary sm-text btn-card-bottom text-uppercase rounded-25 font-weight-bold hover-effect"
                                onClick={(e) => {
                                  e.preventDefault()
                                  if(!syncOrder) {
                                    syncLocalOrders("sync")
                                  }
                                }}
                                >
                                  Sync
                                </button>
                              )
                            }
                        </div>
                        <div className={`${authUserInfo.details.user_type !== "call_center" ? "col-5" : "col-4"} d-flex justify-content-end`}>
                        
                          {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Settle"
                          ) ? (
                            !order_id && authUserInfo.details.user_type !== "call_center" ? (
                              <button
                                disabled={buttonDisabled || (selectedDeliveryType && selectedDeliveryType.name.match(/dine(.*)in/i) && !(parseInt(getSystemSettings(generalSettings, "enable_dinein_settle"))))}
                                type="button"
                                className="mr-1 w-15 btn btn-success3 sm-text btn-card-bottom text-uppercase col-6 rounded-25 font-weight-bold hover-effect"
                                onClick={handleSettleOrderButton}
                              >
                                {!loading ? "settle" : "Please wait"}
                              </button>
                            ) : (
                              ""
                            )
                          ) : (
                            ""
                          )}
                         
                          {authUserInfo.permissions !== null && checkPermission(authUserInfo.permissions,"Submit") ? (
                            <button
                              disabled={buttonDisabled}
                              type="button"
                              className="w-15 btn btn-primary sm-text btn-card-bottom text-uppercase col-6 rounded-25 font-weight-bold hover-effect mr-1"
                              onClick={(e)=>{
                                if(!loading){
                                  handleSubmitOrder(e) 
                                }  
                              }}
                            >
                              {!loading
                                ? _t(t("submit"))
                                :  _t(t("Please wait"))}
                            </button>
                          ) : (
                          checkPermission(authUserInfo.permissions,"FOC Submit") &&
                          !order_id && authUserInfo.details.user_type !== "call_center" && (
                            <button
                              disabled={buttonDisabled}
                              type="button"
                              className="w-15 btn btn-primary sm-text btn-card-bottom text-uppercase col-6 rounded-25 font-weight-bold hover-effect mr-1"
                              onClick={(e)=> {
                                if(!loading){
                                  handleFocConfirmation(e)
                                }
                              }}
                            >
                              {!loading
                                ? _t(t("Foc"))
                                :  _t(t("Please wait"))}
                            </button>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <SettleOrder
        managerId={managerId}
        showSettle={showSettle}
        setSelectedKot={setSelectedKot}
        setShowSettle={setShowSettle}
        selectedDeptTag={selectedDeptTag}
        selectedParty={selectedParty}
        selectedDeliveryType={selectedDeliveryType}
        buttonDisabled={buttonDisabled}
        setButtonDisabled={setButtonDisabled}
        newOrder={newOrder}
        cartItems={cartItems}
        setCartItems={setCartItems}
        cartTotal={cartTotal}
        orderDetails={orderDetails}
        setOrderDetails={setOrderDetails}
        deliveryCharges={deliveryCharges}
        showPriceOfEachOrderItem={(p) =>
          roundOffPrice(
            p.after_tax_price ?? getBeforeTaxPrice(calculatePriceForCartItem(p))
          )
        }
        theVatSettle={theVatSettle}
        setTheVatSettle={setTheVatSettle}
        setPaidMoney={setPaidMoney}
        setNewSettings={setNewSettings}
        newSettings={newSettings}
        totalsettle={totalsettle}
        setTotalSettle={setTotalSettle}
        paidMoney={paidMoney}
        serviceCharges={serviceCharges}
        cartSubTotal={cartSubTotal}
        loyaltyPoint={loyaltyPoint}
        setloyaltyPoint={setloyaltyPoint}
        emptyCardOnChange={emptyCardOnChange}
        tokenNumber={tokenNumber}
        theVat={theVat}
        theTax={theTax}
        setTheVat={setTheVat}
        returnMoneyUsd={returnMoneyUsd}
        setReturnMoneyUsd={setReturnMoneyUsd}
        isSettle={isSettle}
        getPrice={(p) => roundOffPrice(getBeforeTaxPrice(p))}
        handleLocalPrint={handleLocalPrint}
        handleReceiptPrint={handleReceiptPrint}
        handleKotItems={handleKotItems}
        paymentTypeAvailable={paymentTypeAvailable}
        fbrInvoiceNum = {fbrInvoiceNum}
        srbInvoiceNum = {srbInvoiceNum}
        token_No={token_No}
        setModal9Show={setModal9Show}
      />

      <OrderPrint
        token_No={token_No}
        newOrder={newOrder}
        selectedKot={selectedKot}
        foodGroupsToPrint={foodGroupsToPrint}
        cartSubTotal={cartSubTotal}
        cartTotal={cartTotal}
        newSettings={newSettings}
        loyaltyPoint={loyaltyPoint}
        con_Kot={con_Kot}
        totalSettle={totalsettle}
        theVat={theVat}
        theVatSettle={theVatSettle}
        paidMoney={paidMoney}
        orderDetails={orderDetails}
        taxType={taxType}
        returnMoneyUsd={returnMoneyUsd}
        isSettle={isSettle.current}
        srbInvoiceNum={srbInvoiceNum.current}
        fbrInvoiceNum={fbrInvoiceNum.current}
        serviceCharges={serviceCharges}
        deliveryCharges={deliveryCharges}
        selectedDeliveryType={selectedDeliveryType}
        selectedParty={selectedParty}
        selectedDeptTag={selectedDeptTag}
        customerPrint={componentRef}
        component2Ref={component2Ref}
        barcodePrintRef={barcodePrintRef}
      />
    
      {/* Authenticate Modal */}
      {showPasswordPopup ? (
        <PasscodeAuthenticator
          correctPasscode={authUserInfo.details.user_passcode}
          managerPass = {managerPasscode}
          setComponentUnlock={setComponentUnlock}
          setManagerId = {setManagerId}
          thisComponent={componentUnlock}
          onSuccess={onSuccessAuthenticationStaff}
          show={showPasswordPopup}
          hanleCancelAuthenticate={hanleCancelAuthenticate}
        />
      ) : null}

      <PosModal
        handleCardSubmit={handleCardSubmit}
        setOrderDetails={setOrderDetails}
        orderDetails={orderDetails}
        paymentTypeAvailable={paymentTypeAvailable}
        cardModal={cardModal}
        backModal={backModal}
        setBackModal={setBackModal}
        emptyCard={emptyCard}
        cashDetails={cashDetails}
        setCashDetails={setCashDetails}
        noteRiderModal={noteRiderModal}
        setNoteRiderModal={setNoteRiderModal}
        handleSubmitOrder={handleSubmitOrder}
        handlePreOrder={handlePreOrder}
        handlePunchOrder={handlePunchOrder}
      />
      <CustomPosModal
        addReasonOnSubmit={addReasonOnSubmit}
        setAddReasonModalShowing={setAddReasonModalShowing}
        addReasonModalShowing={addReasonModalShowing}
        addFocItem = {addFocItem}
        setAddFocItem = {setAddFocItem}
        handleFocItem = {handleFocItem}
        deleteReason={deleteReason}
        setDeleteReason={setDeleteReason}
        setPaymentTypeModalState={setPaymentTypeModalState}
        paymentTypeModalState={paymentTypeModalState}
        callCenterPayment={callCenterPayment}
        setCallCenterPayment={setCallCenterPayment}
      />


    </>
  );
}

export default Pos;
